<template>
  <div :class="$style.bundle">
    <img
      v-for="itemImage of itemImagesSorted"
      :src="itemImage.url"
      :key="itemImage.key"
      :style="itemImage.styles"
      :class="[$style.bundleItem, $style.animatedItemDown]"
      alt=""
    >
  </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import helpers from '@/lib/helpers';
import { ItemImageTypes } from '@/apps/menu/constants';

@Component({
  name: 'BundlePreview',
})
export default class extends Vue {
  /** @type {Array<Object>} */
  @Prop({
    type:     Array,
    required: true,
  })
  items;

  get itemImagesSorted() {
    return this.items
      .slice()
      .map(this.getItemImage)
      .filter(item => item != null)
      .sort((left, right) => left.displayIndex - right.displayIndex)
      .reduce((acc, image) => {
        if (acc.map(i => i.url).includes(image.url)) {
          return acc;
        }

        return [ ...acc, image ];
      }, [])
      .map((item, i) => ({
        url:    helpers.getImagePath(item.url),
        key:    item.url,
        styles: {
          zIndex: i,
        },
      }));
  }

  /**
   * Returns a meta-information of an image based on the current type of display.
   * @returns {{url: string, displayIndex: number} | undefined} May be `undefined` in case the preview is not available for this type of product in such a scenario.
   */
  getItemImage(item) {
    const bundleImageTypes = [
      ItemImageTypes.configuratorFriesPreviewImage,
      ItemImageTypes.configuratorBowlPreviewImage,
    ];

    const images =
      item.images.filter(image => bundleImageTypes.includes(image.type));

    return images[0];
  }
}
</script>

<style lang="scss" module>
.bundle {
  /* Using single-cell grid to stack elements,
    while preserving the size of images. */
  display: grid;
  grid-template-areas: "main";
  width: 100%;
  height: 100%;
}

.bundleItem {
  grid-area: main;
  width: 100%;
  height: 100%;
  overflow: hidden;
  object-fit: contain;
}

$transition-offset: 5%;

.animatedItemDown {
  animation: down 600ms ease-in normal;
}

@keyframes down {
  from {
    transform: translateY(-$transition-offset);
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/configurator/components/Preview/BundlePreview.vue